import { inject, Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import {
  Customer,
  FavouriteProductListConfigService,
  Product,
  SelectedCustomerService
} from 'gung-standard';
import { first, forkJoin, Observable, of, switchMap } from 'rxjs';
import { OttoOlsenFavouriteProductGridViewComponent } from '../components/otto-olsen-favourite-product-grid-view/otto-olsen-favourite-product-grid-view.component';
import { OttoOlsenFavouriteProductTreeTableViewComponent } from '../components/otto-olsen-favourite-product-tree-table-view/otto-olsen-favourite-product-tree-table-view.component';
import { fnProductName } from '../pipes/product-name.pipe';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OttoOlsenFavouriteProductListConfigService extends FavouriteProductListConfigService {
  public selectedCustomer: Customer;

  private selectedCustomerService = inject(SelectedCustomerService);

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => 'fas fa-th',
        getListItemComponent: () => OttoOlsenFavouriteProductGridViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      },
      {
        getIconClass: () => 'fa fa-list',
        getListItemComponent: () => OttoOlsenFavouriteProductTreeTableViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductList'
      }
    ];
  }

  getSearchTerms(item: Product) {
    let referenceId;
    if (
      this.selectedCustomer &&
      item.extra._customerCrossReferences &&
      item.extra._customerCrossReferences[this.selectedCustomer.id]
    ) {
      referenceId = item.extra._customerCrossReferences[this.selectedCustomer.id].referenceId;
    }
    return [item.id, fnProductName(item), referenceId];
  }

  getItems(): Observable<Product[]> {
    return super.getItems().pipe(
      switchMap(products => {
        return forkJoin([of(products), this.selectedCustomerService.getSelectedCustomer().pipe(first())]);
      }),
      switchMap(([products, customer]) => {
        this.selectedCustomer = customer;
        return of(products);
      })
    );
  }

  getFilters(route?: ActivatedRouteSnapshot): ConfigBaseFilter<Product>[] {
    const filters = super.getFilters(route);
    return filters.filter(f => f?.['filterTitle'] !== 'Rabatt V.Gr');
  }
}
